import React from "react";
import { useSelector } from "react-redux";
import StartOfEffice from "./StartOfEffice/StartOfEffice";
import NoEffices from "./NoEffices/NoEffices";
import { selectCurrentActiveEffice } from "slices/sharedSelectors";
import TextEfficeItem from "../RenderedTextEffices/TextEfficeItem/TextEfficeItem";

const ListStart = ({ myId }) => {
  const currentActiveEffice = useSelector(selectCurrentActiveEffice);
  // window.efs_debug && window.log("LISTSTART RENDERED");
  if (!currentActiveEffice) return null;
  return (
    <>
      {currentActiveEffice.sub_effices === 0 ? (
        <NoEffices
          content={currentActiveEffice.content}
          pinned={currentActiveEffice.pinned}
        />
      ) : null}
      <StartOfEffice />
      {!currentActiveEffice.pinned && currentActiveEffice.parent_id && (
        <div className="original-message-wrapper">
          <TextEfficeItem
            key={currentActiveEffice.id}
            id={currentActiveEffice.id}
            myId={myId}
          />
        </div>
      )}
    </>
  );
};

export default ListStart;
